import { useMemo } from "react"
import { useNormalizedRouterSearchParams } from "hooks/useNormalizedRouterSearchParams"
import { createMapViewConfigByPath } from "utils/map"
import { IBaseFlyToOptions } from "./interface"

// TODO: หลัง Update version maptalks แล้วสามารถใช้ import type { MapViewType } from 'maptalks' แทนได้
type UseGetMapViewFromUrl = () => { mapView: IBaseFlyToOptions | null }

/**
 * Read "mv" from URL and convert and return MapViewType + Timestamp (aka BaseFlyToOptions)
 * @returns maptalks' MapViewType { zoom, bearing, pitch, center }
 */
export const useGetMapViewFromUrl: UseGetMapViewFromUrl = () => {
  const { mv: mapViewQs } = useNormalizedRouterSearchParams()
  const mapView = useMemo(
    () => createMapViewConfigByPath(mapViewQs),
    [mapViewQs]
  )
  return {
    mapView,
  }
}
